export class UploadCompleteRequest
{
	public FileName: string = "";
}



